// extracted by mini-css-extract-plugin
export default {"Content":"LawLibraryFullView_Content__omIOO"};